<div class="row">
    <div class="col-xl-4 col-lg-6 col-md-12" *ngFor="let item of certificates; let i = index">
      <div class="card-container-certificate">
        <div class="card flip-card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <div class="fw-bold text-primary">{{ item.companyName }}</div>
            <div class="text-center">
              <img src="/assets/images/icons/pdf.png" width="20" height="25" class="me-2">
              <h6 class="mb-0 text-dark">{{ item.certificateNo }}</h6>
            </div>
          </div>
  
          <div class="card-body flip-card-body" [class.flipped]="item.isFlipped" [class.qr-visible]="item.isFlipped" *ngIf="!item.isFlipped">
            <div *ngIf="!item.isFlipped" class="d-flex justify-content-between align-items-center">
              <div class="text-center">
                <p class="card-text fw-semibold text-muted">Yayımlanma Tarihi</p>
                <span class="badge bg-primary text-white">{{ item.issueDate | date:'dd.MM.yyyy' }}</span>
              </div>
  
              <div class="align-items-center">
                <a [href]="backendUrl + item.filePath" target="_blank" class="btn btn-flat-success d-flex align-items-center">
                  <i data-feather="download"></i>
                </a>
              </div>
  
              <div class="text-center">
                <p class="card-text fw-semibold text-muted">Geçerlilik Tarihi</p>
                <span class="badge bg-danger text-white">{{ item.expiryDate | date:'dd.MM.yyyy' }}</span>
              </div>
            </div>
          </div>
  
          <!-- QR Kodunu buraya ekliyoruz -->
          <div class="card-body flip-card-body" [class.flipped]="!item.isFlipped" [class.qr-visible]="!item.isFlipped">
            <div class="text-center" *ngIf="item.isFlipped">
              <qrcode [qrdata]="backendUrl + item.filePath" [size]="150"></qrcode>
            </div>
          </div>
  
          <div class="ml-2">
            <button type="button" class="btn btn-icon btn-flat-success flip-button" (click)="toggleFlip(i)">
              <i [data-feather]="'refresh-cw'"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  
<div class="row">
    <div class="col-12 d-flex justify-content-between">
        <p>Toplam Veri <strong>{{totalCount}}</strong></p>
        <ngb-pagination [collectionSize]="totalCount" [(page)]="pageBasic" [pageSize]="selectedSize"
            [directionLinks]="true" (pageChange)="onPageChange($event)" [maxSize]="5">
        </ngb-pagination>
    </div>
</div>